import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Training',
    href: '#training'
  }, {
    name: 'Coaches',
    href: '#coaches'
  }, {
    name: 'Memberships',
    href: '#memberships'
  }, {
    name: 'Location',
    href: '#location'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-zinc-950/95 backdrop-blur-md border-b border-zinc-800 py-4' : 'bg-transparent py-6'}`} data-id="element-112">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-113">
        <a href="#" className="flex items-center gap-2 group" data-id="element-114">
          <div className="w-8 h-8 bg-red-600 flex items-center justify-center transform -skew-x-12 group-hover:scale-105 transition-transform" data-id="element-115">
            <span className="font-display text-white text-xl leading-none" data-id="element-116">
              8
            </span>
          </div>
          <span className="font-display text-2xl tracking-widest text-white uppercase" data-id="element-117">
            Iron Eight <span className="text-red-600" data-id="element-118">MT</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-119">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-display text-xl tracking-wide text-zinc-400 hover:text-white transition-colors uppercase" data-id="element-120">
              {link.name}
            </a>)}
          <Button size="sm" onClick={() => document.getElementById('memberships')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-121">
            Join Now
          </Button>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-zinc-300 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-122">
          {mobileMenuOpen ? <X size={28} data-id="element-123" /> : <Menu size={28} data-id="element-124" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-125">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-zinc-950 border-b border-zinc-800 overflow-hidden" data-id="element-126">
            <div className="container mx-auto px-6 py-6 flex flex-col gap-6" data-id="element-127">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="font-display text-2xl tracking-wide text-zinc-400 hover:text-white uppercase" data-id="element-128">
                  {link.name}
                </a>)}
              <Button className="w-full" onClick={() => {
            setMobileMenuOpen(false);
            document.getElementById('memberships')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-129">
                Join Now
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}